// src/app/catalogues/page.tsx
import type { Metadata } from "next";
import { Header } from "@/components/header/Header";
import InnerHero from "@/components/InnerHero/InnerHero";
import { CatalogPageSection } from "@/components/CatalogPage/CatalogPageSection";
import CTA from "@/components/ProductsPage/CTA/CTA";
import { Footer } from "@/components/Footer/Footer";

export const metadata: Metadata = {
  title: "Catalogues — Queenscraft",
  description:
    "Browse the complete Queenscraft digital catalog library. Explore our full range of handcrafted furniture, lighting, decor and more.",
};

export default function CataloguesPage() {
  return (
    <>
      <Header />
      <main>
        <InnerHero pageKey="catalogues" />
        <CatalogPageSection />
        <CTA />
      </main>
      <Footer />
    </>
  );
}